import { SoilTexture } from '../plots';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedTensiometersThresholds = {
    stress: 110,
    vigilance: 90,
    comfort: 70,
    saturation: 0
};
export const mockedCapacitiveThresholds = {
    stress: 6,
    vigilance: 40,
    comfort: 43,
    saturation: 60
};
export const mockedTensiometersThresholdsProfile = {
    id: 1,
    name: 'Mocked tensiometers thresholds profile',
    linkedPlotNames: ['Mocked tensiometers plot'],
    thresholds: mockedTensiometersThresholds,
    metric: 'HPOT'
};
export const mockedCapacitiveThresholdsProfile = {
    id: 2,
    name: 'Mocked capacitive thresholds profile',
    linkedPlotNames: ['Mocked capacitive plot'],
    thresholds: mockedCapacitiveThresholds,
    metric: 'U_CAPA'
};
export const mockedThresholdsProfilePlotLink = {
    id: 3,
    createdAt: 0,
    plotId: 12,
    thresholds: mockedTensiometersThresholdsProfile.thresholds,
    thresholdsProfileId: mockedTensiometersThresholdsProfile.id,
    thresholdsProfileName: mockedTensiometersThresholdsProfile.name
};
export const mockedDefaultThresholds = {
    [SoilTexture.clay]: {
        saturation: 42,
        comfort: 31,
        vigilance: 27,
        stress: 19
    },
    [SoilTexture.clayLoam]: {
        saturation: 36,
        comfort: 24,
        vigilance: 20,
        stress: 12
    },
    [SoilTexture.loam]: {
        saturation: 29,
        comfort: 19,
        vigilance: 16,
        stress: 9
    },
    [SoilTexture.loamySand]: {
        saturation: 13,
        comfort: 9,
        vigilance: 8,
        stress: 5
    },
    [SoilTexture.sandyLoam]: {
        saturation: 18,
        comfort: 12,
        vigilance: 10,
        stress: 6
    },
    [SoilTexture.sandyClay]: {
        saturation: 36,
        comfort: 27,
        vigilance: 25,
        stress: 19
    },
    [SoilTexture.sandyClayLoam]: {
        saturation: 27,
        comfort: 19,
        vigilance: 16,
        stress: 11
    },
    [SoilTexture.silt]: {
        saturation: 29,
        comfort: 18,
        vigilance: 14,
        stress: 7
    },
    [SoilTexture.siltClay]: {
        saturation: 41,
        comfort: 29,
        vigilance: 25,
        stress: 17
    },
    [SoilTexture.siltyClayLoam]: {
        saturation: 39,
        comfort: 26,
        vigilance: 21,
        stress: 12
    },
    [SoilTexture.siltLoam]: {
        saturation: 32,
        comfort: 21,
        vigilance: 17,
        stress: 9
    },
    [SoilTexture.sand]: {
        saturation: 11,
        comfort: 8,
        vigilance: 7,
        stress: 5
    },
    [SoilTexture.custom]: mockedTensiometersThresholds
};
const mock = {
    getIrritensio: mockedRequester(mockedTensiometersThresholds, 'thresholds.getIrritensio'),
    updateIrritensio: mockedRequester(mockedTensiometersThresholds, 'thresholds.updateIrritensio'),
    /** Thresholds Profiles */
    createThresholdsProfile: mockedRequester(mockedTensiometersThresholdsProfile, 'thresholds.createOrgIrrigationThresholds'),
    getThresholdsProfile: mockedRequester(mockedTensiometersThresholdsProfile, 'irritensio.getThresholdsProfile'),
    updateThresholdsProfile: mockedRequester(mockedTensiometersThresholdsProfile, 'irritensio.updateThresholdsProfile'),
    deleteThresholdsProfile: mockedRequester(undefined, 'irritensio.deleteOrgIrrigationThresholds'),
    getManyThresholdsProfiles: mockedRequester(mockedPaginatedResponse([
        mockedTensiometersThresholdsProfile,
        mockedCapacitiveThresholdsProfile
    ]), 'irritensio.getManyThresholdsProfiles'),
    getAllThresholdsProfiles: mockedRequester([mockedTensiometersThresholdsProfile, mockedCapacitiveThresholdsProfile], 'irritensio.getAllThresholdsProfiles'),
    /** Thresholds Profiles To Plot Links */
    linkThresholdsProfileToPlot: mockedRequester(mockedThresholdsProfilePlotLink, 'irritensio.linkThresholdsProfileToPlot'),
    removeThresholdsProfileFromPlot: mockedRequester(undefined, 'irritensio.removeThresholdsProfileFromPlot'),
    getDefaultThresholds: mockedRequester(mockedDefaultThresholds, 'irritensio.getDefaultThresholds'),
    getThresholdsProfilePlotLinks: mockedRequester([mockedThresholdsProfilePlotLink], 'irritensio.getThresholdsProfilePlotLinks')
};
export default mock;
